/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemAnswerTextCorrectionGridItemRepositoryResponsePaginatedResponse } from "../types/ExamItemAnswerTextCorrectionGridItemRepositoryResponsePaginatedResponse.ts";
import { examItemAnswerTextCorrectionGridItemRepositoryResponseSchema } from "./examItemAnswerTextCorrectionGridItemRepositoryResponseSchema.ts";

export const examItemAnswerTextCorrectionGridItemRepositoryResponsePaginatedResponseSchema =
  z.object({
    data: z
      .array(
        z.lazy(
          () => examItemAnswerTextCorrectionGridItemRepositoryResponseSchema,
        ),
      )
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<ExamItemAnswerTextCorrectionGridItemRepositoryResponsePaginatedResponse>;
